import { Controller, useFormContext, useFormState } from 'react-hook-form';
import { Dropdown as DropdownComponent } from '../../../components/Dropdown/Dropdown.js';
import { fieldCantBeEmptyMsg, selectMsg, t } from '../../i18n/index.js';
import { getTextError } from '../utils.js';
import type { CLDropdownItem } from '../../types/componentLibrary';

export interface DropdownComponentProps {
  className?: string;
  name: string;
  id?: string;
  label?: string;
  items: CLDropdownItem[];
  optional?: boolean;
  disabled?: boolean;
  onValueChange?: (value?: string) => void;
  selectedValue?: string;
}

export const Dropdown = ({
  className,
  name,
  id,
  label,
  items,
  optional = false,
  disabled = false,
  onValueChange = () => {},
  selectedValue,
}: DropdownComponentProps) => {
  const { control } = useFormContext();
  const formState = useFormState({ control });

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: { value: true, message: t.VPVR(fieldCantBeEmptyMsg) } }}
      render={({ field: { onChange, value }, fieldState: { isTouched, error } }) => (
        <DropdownComponent
          className={className}
          i18n_dropdown_placeholderText={optional || (!selectedValue && !value) ? t.QRYV(selectMsg) : undefined}
          label={label}
          items={items}
          id={id}
          onValueChange={element => {
            const newValue = element.dataset.value;
            onChange(newValue);
            onValueChange(newValue);
          }}
          selectedValue={selectedValue ?? value}
          i18n_dropdown_errorMessage={getTextError(formState.isSubmitted, isTouched, error)}
          optional={optional}
          disabled={disabled}
        />
      )}
    />
  );
};
